import { render, staticRenderFns } from "./zPlayer.vue?vue&type=template&id=7570514c&"
import script from "./zPlayer.vue?vue&type=script&lang=js&"
export * from "./zPlayer.vue?vue&type=script&lang=js&"
import style0 from "./zPlayer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports